<template>
    <popup
        :opened="dataToShow"
        :no-close-button="true"
    >
        <h3>Conditions générales d'utilisation du logiciel Neopass</h3>
        <p class="text-center text-sm">
            En vigueur au 28 mars 2021
        </p>

        <div class="my-10 mx-0 lg:mx-15 flex flex-col space-y-5 text-base">
            <div class="flex flex-col space-y-2.5">
                <p>Les présentes Conditions Générales d’Utilisation (“CGU”) sont applicables à tout accès et à toute utilisation du Logiciel dénommé NEOPASS (“le Logiciel”).</p>
                <p>Le Préambule fait partie intégrante des présentes CGU.</p>
            </div>
            <div class="flex flex-col space-y-2.5">
                <h5 class="text-left font-medium">
                Préambule
                </h5>
                <p>L’utilisation du Logiciel, qu’il soit gratuit (Compte d’Essai) ou payant (lorsque l’Utilisateur dispose d’un abonnement au Logiciel) est soumise au respect des présentes CGU par l’Utilisateur. L'Utilisateur confirme avoir lu, compris et accepté les présentes CGU.</p>
                <p>L’utilisation du Logiciel implique également l’acceptation des Conditions Générales de Vente (CGV), lors de la Souscription, par le Créateur du compte, un Administrateur ou un Décisionnaire. Ces Conditions Générales de Vente prévalent sur les présentes CGU.</p>
                <p>MUNEO se réserve le droit de modifier ou d’adapter les présentes CGU à tout moment, en notifiant toute nouvelle version à l’Utilisateur, qui s’engage à prendre connaissance de ces modifications.</p>
            </div>
            <div class="flex flex-col space-y-2.5">
                <h5 class="text-left font-medium">
                Article 1 - Accès au Logiciel
                </h5>
                <p class="font-semibold">
                1.1 Général
                </p>
                <p>MUNEO ne permet l'accès au Logiciel qu'aux personnes spécifiquement autorisées par NEOPASS et ses Utilisateurs.</p>
                <p>MUNEO s’engage à mettre en œuvre tous les moyens permettant à l’Utilisateur un accès fiable et rapide au Logiciel. Un service d’assistance, limité à l’utilisation du Logiciel dans le cadre d’un accès payant, est disponible dans les termes de l’abonnement souscrit.</p>
                <p>De son côté, l’Utilisateur reconnaît que le Logiciel constitue une plate-forme particulièrement complexe, notamment en termes de technologie informatique et s’engage donc à supporter les risques d’inadéquation ou d’indisponibilité du Logiciel.</p>
                <p>MUNEO peut recommander des prérequis techniques ou certaines configurations pour utiliser le Logiciel. L’Utilisateur est responsable du suivi de ces prérequis techniques ou recommandations, et s’assure dans tous les cas que son équipement est compatible avec le Logiciel.</p>
                <p>L’Utilisateur est seul responsable de sa connexion à Internet ainsi que de tous les frais afférents. Il déclare comprendre que MUNEO ne peut pas être tenue responsable en cas d'interruption d’Internet, de virus affectant ses données et/ou logiciels, d’une utilisation abusive des mots de passe de Compte et, plus généralement, de tous les dommages causés par des tiers.</p>
            </div>
            <div class="flex flex-col space-y-2.5">
                <p class="font-semibold">
                1.2 Compte d’Essai
                </p>
                <p>MUNEO offre la possibilité de créer gratuitement un compte pour un Tiers souhaitant évaluer le Logiciel.</p>
                <p>Ce Compte d’essai est mis à disposition pendant une durée de quinze (15) jours à compter de la mise en service et dans les conditions suivantes :</p>
                <p>- Il n’est possible de créer qu’un seul Compte d’essai et cette offre n’est pas renouvelable ;</p>
                <p>- MUNEO peut, à la demande de l’Utilisateur, et sans y être obligée, permettre à l’Utilisateur d’utiliser le Compte d’essai pour une durée supplémentaire de 15 jours ;</p>
                <p>- L’Utilisateur autorisé à utiliser un Compte d’essai reconnaît que l’accessibilité au Logiciel a pour seul objet de lui permettre de tester les fonctionnalités du Logiciel avant la souscription éventuelle d’un abonnement payant. Il s’interdit à ce titre de réaliser des traitements ou des prestations quelconques pour des tiers en utilisant son Compte d’essai ;</p>
                <p>- La Responsabilité de MUNEO ne saurait être engagée à quel titre que ce soit du fait de l’utilisation du Logiciel à titre d’essai. MUNEO ne sera tenue à aucune indemnité d’aucune sorte en cas de dysfonctionnement du Logiciel, pendant toute la durée de l’essai.</p>
                <p>- MUNEO se réserve la possibilité de supprimer sans préavis tout Compte d’essai ne respectant pas les dispositions qui précèdent ou toute autre disposition des présentes CGU.</p>
                <p>Dans l’hypothèse où l’essai n’est pas suivi par la Souscription d’un Compte, MUNEO supprimera le Compte d’essai du Tiers autorisé et les données associées, dans un délai de quatre-vingtdix (90) jours à compter de la fermeture du Compte d’essai.</p>
            </div>
            <div class="flex flex-col space-y-2.5">
                <h5 class="text-left font-medium">
                Article 2 - Utilisation du Logiciel
                </h5>
                <p>L’Utilisateur est seul responsable de l’utilisation et de la mise en œuvre de moyens de sécurité, de protection et de sauvegarde de ses équipements, de ses Contenus et logiciels.</p>
                <p>L’Utilisateur s’engage à ne commettre aucun acte qui pourrait mettre en cause la sécurité de la plate-forme logicielle et utiliser le Logiciel dans le respect des lois et règlements en vigueur.</p>
            </div>
            <div class="flex flex-col space-y-2.5">
                <h5 class="text-left font-medium">
                Article 3 -Responsabilités
                </h5>
                <p>MUNEO met en œuvre les mesures et moyens techniques nécessaires pour assurer la sécurité des connexions, des contenus et des Données à Caractère Personnel de ses Utilisateurs.</p>
                <p>MUNEO fournit le Logiciel au terme d’une obligation de moyens. MUNEO utilise des procédés et techniques conformes à l'état de l'art. Toutefois, en l'état actuel des connaissances, les tests et les expériences ne peuvent couvrir toutes les utilisations possibles.</p>
                <p>MUNEO ne garantit pas que le Logiciel fonctionnera sans interruption ou dysfonctionnement, ou sera exempt d’anomalies ou d’erreurs pouvant être corrigées, ou qu'il est compatible avec du matériel ou une configuration autre que ceux expressément approuvés par MUNEO.</p>
                <p>L'Utilisateur est responsable de :</p>
                <p>- Son accès et de son utilisation du Logiciel ;</p>
                <p>- L’obtention et le maintien de tout l'équipement nécessaire pour accéder au Logiciel ;</p>
                <p>- S’assurer que cet équipement est compatible avec le Logiciel.</p>
                <p>MUNEO se réserve le droit d'interrompre à tout moment et temporairement l’accès au Logiciel :</p>
                <p>- Pour effectuer une mise à jour, des interventions techniques de maintenance ou d'amélioration, qui contribueront à leur bon fonctionnement ou pour réparer une panne : MUNEO fera ses meilleurs efforts pour avertir l’Utilisateur de ces interruptions ;</p>
                <p>- En cas d’indisponibilité des serveurs pour quelque motif que ce soit ;</p>
                <p>- En cas d’impayés, de manquements aux CGU et CGV, d’atteintes par un tiers portées à la sécurité du Logiciel et des Contenus hébergés par MUNEO.</p>
                <p>MUNEO ne sera tenue à aucune indemnité en cas d’interruption temporaire d’accès dans les conditions rappelées ci-dessus.</p>
            </div>
            <div class="flex flex-col space-y-2.5">
                <h5 class="text-left font-medium">
                Article 4 - Propriété intellectuelle
                </h5>
                <p>Le Logiciel appartient sans aucune limitation à MUNEO.</p>
                <p>L’Utilisateur est autorisé à utiliser le Logiciel conformément à la Licence. Tous les droits non expressément accordés par les CGU sont réservés.</p>
                <p>Le Logiciel est une œuvre originale protégée par les droits de propriété intellectuelle et les conventions internationales. L’Utilisateur garantit qu'il ne modifiera, louera, empruntera, vendra ou distribuera pas ces œuvres, ou ne créera pas d’œuvres dérivées basées en tout ou partie sur elle. Il s’engage à ne pas mettre en œuvre de procédé d’ingénierie inverse (rétro-ingénierie), sauf dans les conditions légales.</p>
                <p>Aucune utilisation du nom ou de la marque NEOPASS ne peut intervenir sans son consentement préalable.</p>
                <p>L’Utilisateur reconnaît que MUNEO est l'unique propriétaire de ses droits de propriété intellectuelle, et en particulier du Logiciel. Il ne doit à aucun moment contester cette propriété ou la validité de la propriété intellectuelle de MUNEO ou des droits qui y sont attachés.</p>
                <p>Les éléments disponibles tels que les logiciels, bases de données, fonctionnalités, la plate-forme, les pages Web, textes, photographies, images, icônes, sons, vidéos et plus généralement toutes les informations disponibles pour l’Utilisateur, sont la propriété entière et exclusive de MUNEO.</p>
            </div>
            <div class="flex flex-col space-y-2.5">
                <h5 class="text-left font-medium">
                Article 5 - Résiliation
                </h5>
                <p>En cas de non-respect par l’Utilisateur des présentes CGU, MUNEO se réserve le droit de mettre un terme à son accès ou supprimer son compte.</p>
                <p>NEOPASS se réserve également le droit d’engager toute action aux fins de faire cesser toute atteinte à ses droits et obtenir réparation du préjudice subi.</p>
            </div>
            <div class="flex flex-col space-y-2.5">
                <h5 class="text-left font-medium">
                Article 6 - Protection des Données à Caractère Personnel
                </h5>
                <div>
                MUNEO recueille et traite les données que les Utilisateurs fournissent volontairement afin d'accéder au Logiciel, d’utiliser le Logiciel, ainsi que les données relatives aux préférences des Utilisateurs et au trafic, conformément à sa <a
                    target="_blank"
                    href="https://www.neopass.fr/politique-de-confidentialite%e2%80%8b/"
                    class="underline text-indigo-600"
                >politique de confidentialité</a> et à sa politique de cookies.
                </div>
                <div>
                En accord avec cette <a
                    target="_blank"
                    href="https://www.neopass.fr/politique-de-confidentialite%e2%80%8b/"
                    class="underline text-indigo-600"
                >politique de confidentialité</a>, les informations recueillies par MUNEO font l’objet d’un traitement informatique destiné notamment à gérer l’accès au Logiciel, les abonnements, les prestations de services et de support, l’élaboration d’offres commerciales et marketing, ainsi que pour renforcer et améliorer les produits et contenus ainsi que l’expérience Utilisateur.
                </div>
                <p>Conformément à la réglementation applicable en matière de protection des données personnelles, l’Utilisateur dispose des droits d’accès, de rectification, d’effacement, de limitation, de portabilité des données et le cas échéant d’opposition au traitement. Il peut exercer ces droits en s’adressant au DPO à l’adresse contact@neopass.fr, sous, réserve de justifier de son identité.</p>
            </div>
            <div class="flex flex-col space-y-2.5">
                <h5 class="text-left font-medium">
                Article 7 - Loi applicable
                </h5>
                <p>Les présentes CGU sont régies par le droit français.</p>
                <p>La date effective des CGU est : 28 mars 2021. Dans l’hypothèse où une version traduite des CGU entre en conflit avec la version française, la version française prévaudra.</p>
                <p>DANS LES LIMITES PREVUES PAR LA LOI EN VIGUEUR, TOUT LITIGE QUANT A SA VALIDITE, SON INTERPRETATION OU SON EXECUTION, SERA SOUMIS A LA COMPETENCE EXCLUSIVE DES JURIDICTIONS DU RESSORT DU SIEGE SOCIAL DE MUNEO, Y COMPRIS EN CAS D'APPEL EN GARANTIE OU DE PLURALITE DE DEFENDEURS.</p>
            </div>
        </div>
            

        <div
            class="flex justify-center mb-15"
        >
        <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-indigo-600"
            bg-color-square="bg-indigo-600"
            icon-color="text-white"
            libelle="Accepter les conditions générales d'utilisation"
            :uppercase="true"
            :right="true"
            icon="checkmark-circle-2"
            type-shadow="shadow-indigo"
            @clickAction="acceptCGU()"
        />
        </div>
    </popup>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import axios from '../../api';

import Popup from '../Popup.vue';
import ActionButton from '../ActionButton.vue';

export default {
    components:{
        Popup,
        ActionButton
    },

    props:{
        dataToShow: Boolean
    },

    computed:{
        ...mapGetters({
            backdoor: "app/backdoor",
        }),
    },

    methods:{
        ...mapMutations({
            SET_USER: "auth/SET_USER",
            SET_BACKDOOR: "app/SET_BACKDOOR",
        }),

        ...mapActions({
            me: "auth/me",
        }),

        async acceptCGU(){
            await axios.post("/api/users/acceptCGU");
            this.$emit('accepted', true)
            await this.me();

            //to reload charts on dashboard
            await this.SET_BACKDOOR(0);
            await this.SET_BACKDOOR(1);
        },
    }
}
</script>
